import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  loading: true,
  errorMessage: '',
  data: [],
  paginatedElements: 0,
  searchTerm: '',
  initialData: [],
};

const assetTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.ASSETTYPE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };

    case REDUX_ACTIONS.ASSETTYPE_LIST_SUCCESS:
      return {
        ...state,
        data: [...action.payload.data],
        initialData: [...action.payload.data],
        loading: false,
        paginatedElements: action.payload.paginatedElements,
        errorMessage: '',
      };

    case REDUX_ACTIONS.ASSETTYPE_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: [],
      };

    case REDUX_ACTIONS.ASSETTYPE_SEARCH_CHANGE:
      return {
        ...state,
        searchTerm: action.payload.value,
      };

    case REDUX_ACTIONS.ASSETTYPE_FILTER:
      return {
        ...state,
        data: [
          ...state.initialData.filter((item) =>
            item?.details?.name.toUpperCase().includes(state.searchTerm.toUpperCase())
          ),
        ],
      };

    case REDUX_ACTIONS.ASSETTYPE_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default assetTypesReducer;
